import { Paper } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { finalizarObra, getGestionObra, getVisualizacionCertificadoPresentacion, getVisualizacionFormularioCargado, getVisualizarUltimoFormularioCargado } from "../../../redux/actions/obra";
import ConfirmDialog from "../../commons/dialog/ConfirmDialog";
import PdfDialog from "../../commons/file/PdfDialog";
import HeaderForm from "../../commons/labels/HeaderForm";
import { enumTiposGestion, tipoGestionToEnum } from "../nuevaObra/commons/enumTipoGestion";
import GestionDeObraTable from "./GestionDeObraTable";
import ProgramaSeguridadContainer from "./programaSeguridad/ProgramaSeguridadContainer";

const GestionDeObraContainer = () => {
  const dispatch = useDispatch();
  const gestionObras = useSelector((state) => state.obra.gestionDeObra);
  const loadingFinalizarObra = useSelector((state) => state.obra.finalizarObra.loading);
  const [dialogOpen, setDialogOpen] = useState();
  const [pdf, setPdf] = useState();
  const [obraAFinalizar, setObraAFinalizar] = useState();
  const [obraSeleccionada, setObraSeleccionada] = useState();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(getGestionObra());
  }, []);

  const onVerObra = useCallback((rowData) => {
    dispatch(getVisualizarUltimoFormularioCargado(rowData.idGestionObra)).then((data) => {
      setPdf(data?.value?.data?.base64);
    });
    setDialogOpen("verObra")
  }, []);

  const onVerFormularioCargado = useCallback((rowData) => {
    dispatch(getVisualizacionFormularioCargado(rowData.idAvisoObra)).then((data) => {
      setPdf(data?.value?.data?.base64);
    });
    setDialogOpen("verObra")
  }, []);

  const onOpenFinalizarObra = useCallback((rowData) => {
    setObraAFinalizar(rowData.idGestionObra);
    setDialogOpen("finalizarObra");
  }, []);

  const onFinalizarObra = useCallback(() => {
    dispatch(finalizarObra(obraAFinalizar)).then(() => {
      setDialogOpen(false);
      // Refresh de las obras
      dispatch(getGestionObra());
    })
  }, [obraAFinalizar]);

  const onVerCertificadoDePresentacion = useCallback((rowData) => {
    dispatch(getVisualizacionCertificadoPresentacion(rowData.idAvisoObra)).then((data) => {
      setPdf(data?.value?.data?.base64);
    });
    setDialogOpen("certificadoCobertura")
  }, []);

  const onGestionarObra = useCallback((rowData) => {
    // Para evitar problemas de sincronizacion aca obtenemos el estado actual de gestion de obra
    dispatch(getGestionObra(rowData.idGestionObra)).then((res) => {
      let dataGestionObra = res.value.data[0];
      const ultimoAvisoObra = dataGestionObra.avisosObra.reduce((a, b) => (a.idAvisoObra > b.idAvisoObra ? a : b), dataGestionObra.avisosObra[0])
      const ultimoAvisoExtension = dataGestionObra.avisosObra.reduce((a, b) => {
        if (b.fechaExtension) {
          if (a === undefined) {
            return b
          } else {
            return a.idAvisoObra > b.idAvisoObra ? a : b;
          }
        }
        return a;
      }, undefined)
      navigate("/obras/nuevaObra", {
        state: {
          estado: dataGestionObra.estado,
          idGestionObra: dataGestionObra.idGestionObra,
          idAvisoObra: ultimoAvisoObra.idAvisoObra,
          tipoAvisoObra: tipoGestionToEnum(ultimoAvisoObra.tipo),
          periodosSuspension: dataGestionObra.avisosObra.filter((avisoObra) => tipoGestionToEnum(avisoObra.tipo) === enumTiposGestion.reinicio).map((avisoObraSuspension) => ({
            fechaSuspension: new Date(avisoObraSuspension.fechaSuspension),
            fechaReinicio: new Date(avisoObraSuspension.fechaReinicio)
          })),
          ultimaFechaExtension: ultimoAvisoExtension ? new Date(ultimoAvisoExtension.fechaExtension) : null,
          informadoSRT: ultimoAvisoObra.informadoSRT,

        }
      })
    });

  }, [navigate]);

  const onOpenProgramaSeguridad = useCallback((rowData) => {
    setDialogOpen("adjuntarProgramaSeguridad");
    setObraSeleccionada(rowData);
  }, []);

  const handleClosePdf = () => {
    setDialogOpen(false);
    setPdf(false);
  }

  return (
    <Paper
      style={{ overflow: "hidden", height: "fit-content", minHeight: 650 }}
    >
      <HeaderForm title="Gestión de Obras" />
      <GestionDeObraTable
        data={gestionObras.data}
        onVerObra={onVerObra}
        onVerFormularioCargado={onVerFormularioCargado}
        onOpenFinalizarObra={onOpenFinalizarObra}
        onVerCertificadoDePresentacion={onVerCertificadoDePresentacion}
        onGestionarObra={onGestionarObra}
        onOpenProgramaSeguridad={onOpenProgramaSeguridad}
        loading={gestionObras.loading}
      />
      {
        {
          verObra: <PdfDialog
            open={dialogOpen}
            file={pdf}
            controllers
            handleClose={handleClosePdf}
            printable
            closeButton
            acceptButton={false}
          />,
          certificadoCobertura: <PdfDialog
            open={dialogOpen}
            file={pdf}
            controllers
            handleClose={handleClosePdf}
            printable
            closeButton
            acceptButton={false}
          />,
          adjuntarProgramaSeguridad: (
            <ProgramaSeguridadContainer
              obra={obraSeleccionada}
              open={dialogOpen}
              handleClose={() => setDialogOpen(false)}
            />
          ),
          finalizarObra: (
            <ConfirmDialog
              title="Finalizar Obra"
              text="Por favor confirmar la finalización de la obra"
              open={dialogOpen}
              handleClose={() => setDialogOpen(false)}
              handleConfirm={onFinalizarObra}
              loading={loadingFinalizarObra}
            />
          )

        }[dialogOpen]
      }
    </Paper>
  )
}

export default GestionDeObraContainer;